export default __webpack_public_path__ + "static/media/logos-facebook.636d99ab.svg";